"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisitor = void 0;
const getOS = () => {
    if (navigator.userAgent.indexOf('Win') !== -1)
        return 'win';
    if (navigator.userAgent.indexOf('Mac') !== -1)
        return 'darwin';
    if (navigator.userAgent.indexOf('Linux') !== -1)
        return 'linux';
    if (navigator.userAgent.indexOf('Android') !== -1)
        return 'android';
    if (navigator.userAgent.indexOf('like Mac') !== -1)
        return 'ios';
    return 'unknown';
};
// https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#testing_for_availability
const localStorageAvailable = () => {
    try {
        const dummy = '__local_storage_test__';
        localStorage.setItem(dummy, dummy);
        localStorage.getItem(dummy);
        localStorage.removeItem(dummy);
        return true;
    }
    catch (e) {
        return false;
    }
};
const getVisitor = () => {
    if (!localStorageAvailable()) {
        return 'unknown';
    }
    const key = 'galileo_web_sdk_visitor';
    const value = localStorage.getItem(key);
    if (!value) {
        const newValue = `${getOS()}-${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
        localStorage.setItem(key, newValue);
        return newValue;
    }
    return value;
};
exports.getVisitor = getVisitor;
